// extracted by mini-css-extract-plugin
export default {"container":"RefPrice_container__8T8OE","price":"RefPrice_price__DOcFu","empty":"RefPrice_empty__PDRWH"};